// test861
(861 && 0);
